module.exports = __webpack_public_path__ + "img/bannerN1.2ea33ba4.png";